import React from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import Filter from 'rp-react-common/Filter';
import FilteringComponent from '../../../shared/filter';
import categoriesFactory from './categories';
import categoriesReducer from './categoriesReducer';
import sireColumns from '../sire/columns';
import damsSireColumns from '../damsSire/columns';

const getColumns = tab => (
    !tab || tab === 'progeny'
        ? sireColumns
        : damsSireColumns
);

class ProgenyCommon extends FilteringComponent {
    constructor(props) {
        super(props);

        const {
            progenyHorses,
            damSireProgenyHorses,
            seasonInfo,
        } = props.data;

        const { seasonsAvailable } = props.availableSeasonsData.data || {};

        this.state = {
            data: progenyHorses || damSireProgenyHorses,
            categories: seasonsAvailable &&
                        categoriesFactory(seasonsAvailable, seasonInfo),
            loading: false,
            fetchError: false,
        };
    }

    componentDidMount() {
        this.onFilterApply(this.state.categories);
    }

    buildUrl = ({ raceType, timePeriod }) => {
        const { id, tab } = this.props;
        return `horse/filter/${tab || 'progeny'}/${id}/${timePeriod}/${raceType}`;
    };

    onDataReceive = ({ progenyHorses, damSireProgenyHorses }) => {
        this.setState({
            data: progenyHorses || damSireProgenyHorses || this.emptyData,
            loading: false,
        });
    };

    render() {
        const {
            data, categories, loading, fetchError,
        } = this.state;
        const { tab } = this.props;
        const columns = getColumns(tab);

        return (
            <section className="hp-sire-progeny">
                {categories && (
                    <Filter
                        categories={categories}
                        categoriesReducer={categoriesReducer}
                        columns={columns}
                        fetchError={fetchError}
                        onFilterApply={this.onFilterApply}
                    />
                )}
                {!fetchError && (
                    <RpTable
                        data={data}
                        columns={columns}
                        loading={loading}
                        initialSortIdx={8}
                        sortable
                        resultsPerPage={50}
                        noDataText="No progeny for this sire in the Racing Post database"
                    />
                )}
                <div className="pp-bottomText">
                    Details of horses trained outside GB and Ireland or born prior to 1986 may be
                    incomplete. OR Rating is the latest published.
                </div>
                <div className="pp-bottomText">
                    Progeny in magenta coloured text denotes a female horse.
                </div>
            </section>
        );
    }
}

const SireProgenyType = {
    countryOriginCode: PropTypes.string,
    damSireCountryOriginCode: PropTypes.string,
    damSireStyleName: PropTypes.string,
    damSireUid: PropTypes.number,
    horseName: PropTypes.string,
    horseUid: PropTypes.number,
    places: PropTypes.number,
    rpPostmark: PropTypes.number,
    runs: PropTypes.number,
    totalPrizeMoney: PropTypes.number,
    winPercent: PropTypes.number,
    wins: PropTypes.number,
};

const DamsSireProgenyType = {
    ...SireProgenyType,
    bestOr: PropTypes.number,
    horseAge: PropTypes.number,
    horseSexCode: PropTypes.string,
    sireCountryOriginCode: PropTypes.string,
    sireStyleName: PropTypes.string,
    sireUid: PropTypes.number,
};

ProgenyCommon.propTypes = {
    data: PropTypes.shape({
        progenyHorses: PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.shape(SireProgenyType),
            PropTypes.shape(DamsSireProgenyType),
        ])),
        seasonInfo: PropTypes.shape({
            raceType: PropTypes.string,
            seasonYearBegin: PropTypes.number,
            seasonYearEnd: PropTypes.number,
        }),
    }).isRequired,
    id: PropTypes.string,
    tab: PropTypes.string,
    availableSeasonsData: PropTypes.shape({
        data: PropTypes.shape({
            FLAT: PropTypes.arrayOf(PropTypes.shape({
                seasonStartYear: PropTypes.string,
                seasonEndYear: PropTypes.string,
            })),
            JUMPS: PropTypes.arrayOf(PropTypes.shape({
                seasonStartYear: PropTypes.string,
                seasonEndYear: PropTypes.string,
            })),
        }),
    }),
    weatherbysUid: PropTypes.string,
};

export default ProgenyCommon;



// WEBPACK FOOTER //
// ./src/js/horse/progeny/components/ProgenyCommon.jsx